export default __webpack_public_path__ + "static/media/writing-competition-banner.b81de940.png";